export const getCpapFollowupFileFolder = (fileType) =>
  fileType === "usageReports" ? "reports" : "questionaires";

export const buildCpapFollowupFileData = ({
  file,
  hn,
  fileType,
  followupUuid,
  userName,
  savedFileName,
  storagePath,
  url,
  uploadedAt = new Date().toISOString(),
}) => ({
  fileName: file.name,
  savedFileName,
  storagePath,
  url,
  uploadedAt,
  uploadedBy: userName,
  hn,
  fileType,
  followupUuid,
});

export const normalizeCpapFollowupFileData = ({ id, data = {}, hn = "" }) => ({
  id: id || "",
  fileName: data.fileName || "",
  savedFileName: data.savedFileName || "",
  storagePath: data.storagePath || "",
  url: data.url || "",
  uploadedAt: data.uploadedAt || "",
  uploadedBy: data.uploadedBy || "",
  hn: data.hn || hn,
  followupUuid: data.followupUuid || "",
  fileType: data.fileType || "",
});

export const splitCpapFollowupFileDocs = (fileDocs = [], hn = "") => {
  const usageReports = [];
  const questionnaires = [];

  fileDocs.forEach((fileDoc) => {
    const data =
      fileDoc && typeof fileDoc.data === "function" ? fileDoc.data() : {};
    const fileData = normalizeCpapFollowupFileData({
      id: fileDoc && fileDoc.id,
      data,
      hn,
    });

    if (data.fileType === "questionnaires") {
      questionnaires.push(fileData);
    } else {
      usageReports.push(fileData);
    }
  });

  return {
    usageReports,
    questionnaires,
  };
};

export const normalizeSleepStudyReportDocs = (
  reportDocs = [],
  hn = "",
  options = {},
) => {
  const files = [];
  const {
    idPrefix = "",
    sourceCollection = "report",
    storageFolder = "reports",
  } =
    typeof options === "string" ? { storageFolder: options } : options || {};

  reportDocs.forEach((reportDoc) => {
    const data =
      reportDoc && typeof reportDoc.data === "function" ? reportDoc.data() : {};
    const reportFile = Array.isArray(data.reportFile)
      ? data.reportFile
      : data.reportFile
        ? [data.reportFile]
        : [];
    const docId = (reportDoc && reportDoc.id) || "";
    const docHn = data.hn || hn;

    reportFile.forEach((fileName, index) => {
      if (!fileName) return;
      const normalizedIdPrefix = idPrefix ? `${idPrefix}-` : "";

      files.push({
        id: `${normalizedIdPrefix}${docId}-${index}`,
        fileName,
        savedFileName: fileName,
        storagePath: `${storageFolder}/${docHn}/${docId}/${fileName}`,
        url: "",
        uploadedAt: data.createAt || data.uploadedAt || "",
        uploadedBy: data.createBy || data.uploadedBy || "",
        hn: docHn,
        followupUuid: "",
        fileType: "sleepStudyReports",
        sourceDocId: docId,
        sourceCollection,
      });
    });
  });

  return files;
};
